import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        item: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            px: remCalc(0),
            gap: ['medium.base', 'medium.sm', 'medium.md', 'small.lg'],
            border: 'none',
            color: 'text.default',
        },
        itemButton: {
            textStyle: 'body-large',
            fontWeight: '500',
        },
        itemIcon: {
            width: 'iconsSize.medium',
            height: 'iconsSize.medium',
        },
    },
}

/*
normal: 400;
medium: 500;
bold: 700;
*/
